import React, { useState } from 'react';
import './Team.css';

// Importing images
import profile1 from '../Assets/satya.jpg';
import profile3 from '../Assets/jay.jpg';
import profile2 from '../Assets/madhuri.jpg';
import profile4 from '../Assets/Picture1[1].png';
import logo from '../Assets/watermark.png';

const Team = () => {
  const [mainProfile, setMainProfile] = useState({
    image: logo,
    name: 'VAJRA IOT',
    role: 'Innovating the Future',
    description:
      'We comprise a team of highly motivated individuals with a solid background and a proven track record in conceptualizing, customizing, and implementing field-ready solutions.',
  });

  const teamMembers = [
    {
      name: 'SATYA PRASAD SAYALA',
      role: 'CEO & DIRECTOR',
      image: profile1,
      experience: 'Experiance: 36 Years',
      description:
        'Satya, is a seasoned Technocrat, with 36 years of wide experience in Electronics, RF Engineering, Telecommunications and IT& ITES sectors, having worked with some of the most credible and successful organizations of global reputation. He holds his major strengths in Digital transformation, new product rollouts, solutions, Automation, Expansion of Telecom/ITES services. He had handled International Business operations involving mergers & acquisitions, take over and migration of Business.',
    },
    {
      name: 'CHANDRAHAS KOLLA (IIT Chennai)',
      role: 'TECHNICAL DIRECTOR',
      image: profile4,
      experience: 'Experiance: 12 Years',
      description:
        'Chandrahas Kolla is an Electrical Engineering graduate from IIT Madras, who subsequently transitioned into roles in biomedical research and corporate consulting With over decade of experience in corporate governance. He serves as a Designated Partner and Director at multiple companies including Hovervdock LLP, Emesco Farms. He currently holds a principal consultant role at Birlasoft and has contributed significantly to business and technology strategy across several ventures',
    },
    {
      name: 'MADHURI JONNALAGADDA',
      role: 'DIRECTOR',
      image: profile2,
      experience: 'Experiance: 22 Years',
      description:
        'Madhuri Jonnalagadda, is a result oriented and experienced global risk and compliance executive with over 22 years of experience working for Fortune 500 companies. She has demonstrated a strong technology and business acumen providing control and oversight on risk frameworks. She worked in dynamic and fast-paced environments and has demonstrated an ability to multi-task, communicate clearly and concisely, and lead strategy. She is adept at problem-solving and has served as a trusted advisor to senior management. In the past she worked with the State Governments on Bid Advisory and Privatization Services and she was a co-founder and executive officer of a tech start-up which was positioned and acquired by HSBC under her leadership.',
    },
    {
      name: 'JAYA RAO GOTRU',
      role: 'GENERAL MANAGER',
      image: profile3,
      experience: 'Experiance: 17 Years',
      description:
        'Jaya Rao, is R&D Professional with over 17 years of experience in design, conceptualization and development of microcontroller/microprocessor-based products and solutions for IoT, Wireless solutions, telecom, infra and power sectors. He is also a Key contributor in all stages of prototype/product development from concept to implementation, Possess strong technical skills and hands on in Embedded Technologies He was associated in the past with Sugan Automatics Pvt. Ltd as a Embedded Software Engineer. Jaya has a B.Tech degree in Electronics and Communication Engineering.',
    },
  ];

  return (
    <div className="team-container">
      <div className="left-panel">
        <img
          src={mainProfile.image}
          alt="Main Profile"
          className="main-profile"
        />
        <h2>{mainProfile.name}</h2>
        <p className="role-text">{mainProfile.role}</p>
        <p className="description">{mainProfile.description}</p>
        <div className="contact-info">
          <p></p>
        </div>
      </div>
      <div className="right-panel">
        <h1 className="team-title">Meet The Team</h1>
        <div className="team-members">
          {teamMembers.map((member, index) => (
            <div
              className="team-member"
              key={index}
              onMouseEnter={() => setMainProfile(member)}
              onMouseLeave={() =>
                setMainProfile({
                  image: logo,
                  name: 'VAJRA IOT',
                  role: 'Innovating the Future',
                  description:
                    'We comprise a team of highly motivated individuals with a solid background and a proven track record in conceptualizing, customizing, and implementing field-ready solutions.',
                })
              }
            >
              <div className="member-info">
                <img src={member.image} alt={member.name} className="member-photo" />
                <div className="member-text">
                  <h3>{member.name}</h3>
                  <p className="role-text">{member.role}</p>
                  <p className="experience-text">{member.experience}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;